
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-68 -34)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","fill-rule":"nonzero","d":"M80 34c-6.626 0-12 5.374-12 12s5.374 12 12 12 12-5.374 12-12-5.374-12-12-12zm5.48 9.356c.004.118.007.237.007.356 0 3.64-2.77 7.837-7.837 7.837a7.8 7.8 0 01-4.222-1.237 5.522 5.522 0 004.078-1.142 2.757 2.757 0 01-2.573-1.912 2.757 2.757 0 001.244-.047 2.757 2.757 0 01-2.21-2.7v-.036c.372.207.796.331 1.248.345a2.75 2.75 0 01-1.225-2.293c0-.504.136-.977.373-1.384a7.816 7.816 0 005.677 2.877 2.756 2.756 0 014.693-2.513 5.5 5.5 0 001.75-.668 2.77 2.77 0 01-1.212 1.524 5.525 5.525 0 001.582-.434 5.595 5.595 0 01-1.374 1.426z"}})])])
          )
        }
      }
    